import { Component, OnInit } from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {Title} from '@angular/platform-browser';
import { isString } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from './api/loader.service';
import { NotificationService } from './services/notification.service';
import { NavigationService } from './services/sds/navigation.service';
import { environment } from '../environments/environment';
// import firebase from 'firebase';

// var firebaseConfig = {
//   apiKey: "AIzaSyAL4co7NYnTCbwBbz2cvYqe5x2HMwJ4Fn8",
//   authDomain: "tddemochat.firebaseapp.com",
//   projectId: "tddemochat",
//   storageBucket: "tddemochat.appspot.com",
//   messagingSenderId: "661022073970",
//   appId: "1:661022073970:web:22137fd67bb70ca8404eeb",
// }

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [],
    standalone: false
})

export class AppComponent implements OnInit{
  
  showNavBar=true;
  showLoader: boolean;
  assistance_tickets_title = false;

  constructor(
    private loaderService: LoaderService, titleService: Title,
    private router: Router, private translate: TranslateService,
    private notificationService: NotificationService,
    private navigationService: NavigationService) {
    
    // firebase.initializeApp(firebaseConfig);
    
    this.showLoader = false;
    this.translate.setDefaultLang('es');
    let lang = 'es';
    if (isString(navigator.language)) {
      if (navigator.language.match(/es/)) {
        lang = 'es';
      }
    }
    let previousUrl: string = this.router.url;
    this.translate.use(lang);
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentUrl = this.router.url;
        const title = this.getTitle(
          router.routerState,
          router.routerState.root
        ).join('-');
        if (title) {
          this.translate.get(title).subscribe(resp => {
            if (this.assistance_tickets_title === true) {
              const urls = router.routerState.snapshot.url.split('/');
              const ticketId = urls[4];
              resp = resp.replace('[id]', ticketId);
            }
            titleService.setTitle(resp);
          });
        } else {
          titleService.setTitle(title);
        }
        if (previousUrl.includes('/sinister-process') && (currentUrl.includes('/sds-search-engine') || currentUrl.includes('/my-pendings'))) {
          this.navigationService.setNavigationEvent('procedureToSearch');
          previousUrl = null;
        }
        previousUrl = currentUrl;
      }
    });
  
    localStorage.removeItem('firebase:previous_websocket_failure');
  }

  getTitle(state, parent) {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      this.assistance_tickets_title = parent.snapshot.data.assistance_tickets_title;
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(... this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }
  

  ngOnInit() {
    const mapsScript = document.createElement('script');
    mapsScript.src = `https://maps.google.com/maps/api/js?v=3&libraries=places&key=${environment.googleMapsApiKey}&callback=angularGmapGuard`;
    mapsScript.async = true;
    mapsScript.defer = true;
    document.head.appendChild(mapsScript);

    const hostname = window.location.hostname;

    if (hostname.includes('localhost') || hostname.includes('dev.apolo11.online') || hostname.includes('apolo11.online')) {
      document.body.classList.add('theme-asi');
    } else if (hostname.includes('127.0.0.1') || hostname.includes('dev.system.guro.digital') || hostname.includes('system.guro.digital')) {
      document.body.classList.add('theme-guro');
    } else if (hostname.includes('dev.aoraservice.com') || hostname.includes('aoraservice.com')) {
      document.body.classList.add('theme-aoraservice');
    } else {
      document.body.classList.add('theme-asi');
    }
     
      
    this.loaderService.status.subscribe((val: boolean) => {
      setTimeout(() => {
        this.showLoader = val;
      });
    });
  }

  checkurl() {
    var urllogin=false
    if (this.router.url == "/admin/assistance/case/survey") urllogin=true
    else if (this.router.url.includes('/login') || this.router.url=='/' || this.router.url.includes('/public')
        || this.router.url.includes('/getclientlocation') || this.router.url.includes('/survey') || this.router.url.includes('/verification/activate')
        || this.router.url.includes('/passwordrecovery') || this.router.url.includes('/tokenrecovery') || this.router.url.includes('/changepasswordrecovery')) urllogin=false
     
    else urllogin = true
     
    return urllogin  
 }
 
}
